<template>
  <div>
    <div v-show="onProviderRoute">
      <Grid :providers="localProviders" :games="games" />
    </div>

    <router-view :providers="localProviders" :games="games"></router-view>
  </div>
</template>

<script>
import Grid from "./components/grid";

export default {
  props: ["providers", "games"],

  data: () => ({
    localProviders: [],
  }),

  components: { Grid },

  created() {
    this.localProviders =
      this.providers && this.providers.length > 0
        ? this.providers
        : this.$store.state.casinoProviders;

    this.$nextTick(() => {
      this.$vuetify.goTo(0);
    });
  },

  computed: {
    onProviderRoute() {
      return this.$route.name === "casinoProvider";
    },
  },
};
</script>

<style></style>
